export const ReviewsModuleName = 'Reviews';